/**
 * Content Verification Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface PartnerContentVerificationModel { 
    id: string;
    code?: string;
    startDate: Date;
    endDate: Date;
    dateCreated: Date;
    serviceProviderId?: string;
    partnerId?: string;
    data?: string;
    message?: string;
}
